<template>
  <b-container fluid>
    <h2>Image List</h2>
    <p>View sky cameras, charts and satellite images</p>
    <b-row>
      <b-col sm="7" order-sm="12">
        <b-img :src="selectedImage.url" fluid></b-img>
        <div>
          <small v-if="selectedImage">Image last retrieved {{ selectedImage.date }}</small>
        </div>
      </b-col>
      <b-col sm="5" class="scroll">
        <b-list-group>
          <b-list-group-item :active="selectedImage.url == image.url" @click="selectedImage = image" href="#" v-for="image in response" :key="image.slug">
            {{ image.name }} - <small>{{ image.description }}</small>
            <b-badge class="float-right">{{ image.categories.toString(', ') }}</b-badge>
          </b-list-group-item>
        </b-list-group>
        <!-- <b-table small hover :items="response" :fields="['image_id', 'description', 'url']">
          <template slot="url" slot-scope="data">
            <a href="#" @click="selectedImage = data.item.url">{{ data.item.url }}</a>
          </template>
        </b-table> -->
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import {
  get
} from 'lodash'
import {
  DateTime
} from 'luxon'

import axios from 'axios'

export default {
  name: 'kp27day',
  mounted() {
    axios.post('https://v2.api.auroras.live/', {
        "modules": ['images'],
        "format": {
          "date": {
            "tz": (window.localStorage.getItem('auroraslive-tz') || (new Date).getTimezoneOffset()),
            "format": "D M jS h:ia Y P"
          },
        }
      }, {
        withCredentials: true // Use this so cookies are properly set
      })
      .then(function(response) {
        this.response = response.data["images"]
      }.bind(this))
      .catch(function(error) {
        this.error = "There was an error loading the data. The error returned as " + error
      }.bind(this))
      .then(function() {
        this.appdata.loading = false
      }.bind(this))
  },
  methods: {
    track () {
      this.$ga.page(this.$route.path)
    }
  },
  data() {
    return {
      response: [],
      selectedImage: '',
      ld: {
        get: _.get
      },
      error: '',
      DateTime: DateTime,
      appdata: {
        loading: false
      }
    }
  }
}
</script>
<style>
  .scroll {
    height: 85vh;
    overflow-y: scroll;
  }
</style>
